<div class="card shear">
  <div class="shear-inner bg-img" style="height: max(min(45vw, 70vh), 300px);">
    <div class="inner-content d-flex flex-column h-100 justify-content-center align-items-center">
      <img ngSrc="https://cdn.sersoft.de/img/sersoft/logo_normal.svg" width="568" height="520"
           alt="ser.soft Logo" i18n-alt class="w-auto h-100 p-5" style="max-height: 40rem;"/>
    </div>
  </div>
</div>
